<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>Vehicle Tracking</strong>
          </div>

          <b-row>
            <b-col sm="4">
              <b-form-group label="Select Vehicle :" :label-cols="3" class="mb-4">
                <v-select v-model="selected_vehicleno" @input="selectsearchvehicle(selected_vehicleno)" :options="vehicleitems" placeholder="-- Select Vehicle NO --"></v-select>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group label="Trip Id:" :label-cols="3" >
                <v-select
                  v-model="selectedTripId"
                  :options="tripIdItems"
                  placeholder="-- Select Trip Id --"
                  :disabled="!selected_vehicleno"
                ></v-select>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group label="From Date:"  :label-cols="3" >
                <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
               </v-date-picker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <b-form-group label="To Date:"  :label-cols="3" >
                <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                </v-date-picker>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-button variant="primary" @click="VehicleListings(pageNum)"> Search </b-button>&nbsp;&nbsp;
              <b-button variant="danger" @click="clear()"> Clear </b-button>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col sm="12" class="text-right  " >
                <b>Total Records :<span style="color:red;">{{ totalRows }}</span></b> 
            </b-col>
            <b-col md="12">
              <b-table
                show-empty
                responsive
                :items="vehiclelist"
                :busy="isBusy"
                :current-page="currentPage"
                :fields="fields"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :bordered="bordered"
              >
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
                <template slot="driverfirstname" slot-scope="row">
                  <span v-if="row.item.driverfirstname != null">
                    <span v-if="row.item.driverlastname != null">
                      {{row.item.driverfirstname + row.item.driverlastname}}
                    </span></span>
                </template>
                <!-- <template slot="startlatlong" slot-scope="row">
                  <span v-if="row.item.startlatlong != null && row.item.startlatlong != ''">{{row.item.startlatlong.split(",")[0]}}</span>
                </template>
                <template slot="endlatlong" slot-scope="row">
                  <span v-if="row.item.startlatlong != null  && row.item.startlatlong != ''">{{row.item.startlatlong.split(",")[1]}}</span>
                </template> -->
                <template slot="Action" slot-scope="row">
                  <b-button variant="light" @click="openmodelriderdetails(row.item)">
                    <i class="fa fa-location-arrow" style="font-size: 19px;"></i>
                  </b-button>&nbsp;&nbsp;
                  <b-button  variant="light" @click="viewMapData(row.item)">
                    <i class="fa fa-map-marker" style="font-size: 17px;"></i>
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12" class="text-right">
              <br>
                   <p style="margin-top: 5px;"> <b>Total Records :<span style="color:red;"> {{totalRows}}</span></b> </p>
            </b-col>
            <b-col md="12" class="my-1" >
                <paginate 
                    :page-count="noofpages"
                    :page-range="10"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'">
                </paginate>
            </b-col>   
        </b-row> 

          <b-modal hide-footer title="View Vehicle Tracking Details" v-model="viewriderlogdetails" size="xl">
            <div>
              <b-col md="12">
                <b-table
                  show-empty
                  responsive
                  :items="riderlist"
                  :busy="isBusymodel"
                  :fields="fieldsr"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  :bordered="bordered"
                >
                  <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                  <!-- <template slot="startlatlong" slot-scope="row">
                    <span v-if="row.item.startlatlong != null  && row.item.startlatlong != ''">{{row.item.startlatlong.split(",")[0]}}</span>
                  </template>
                  <template slot="endlatlong" slot-scope="row">
                    <span v-if="row.item.endlatlong != null  && row.item.endlatlong != ''">{{row.item.endlatlong.split(",")[1]}}</span>
                  </template> -->
                </b-table>
              </b-col>
            </div>
            <hr>
            <br>
            <b-button class="float-right" variant="danger" @click="hideModal">Close Me</b-button>
          </b-modal>
          <!-- @shown="initMap" -->

          <b-modal hide-footer title="View Map Details" v-model="viewmap" size="xl" @shown="initMapLoad">
            <b-row>
              <!-- <b-col md="12">
                <span class="green-dot"></span> <span class="dot">start Point</span> &nbsp; <span class="yellow-dot"></span><span class="dot">Between Point</span> &nbsp; <span class="red-dot"></span><span class="dot">End Point</span>
              </b-col> -->
              <b-col md="12">
               <b-card>
                <div id="map" style="height: 500px;"></div>
               </b-card>
              </b-col>
            </b-row>
          </b-modal>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from "vue";
export default {
  data() {
    return {
      selectDateFrom: new Date(),
      selectDateTo:new Date(),
      vehiclelist: [],
      fields: [
        { key: "tripid", label: "Trip Id", sortable: true },
        { key: "driverfirstname", label: "Driver Name", sortable: true },
        { key: "vehicle_no", label: "Vehicle Number", sortable: true },
        { key: "startlatlong", label: "Start Latlong", sortable: true },
        { key: "endlatlong", label: "End Latlong", sortable: true },
        { key: "total_distance", label: "Total Distance", sortable: true },        
        { key: "expectedArrivalDate", label: "Expected Arrival Date", sortable: true },
        { key: "origin_hub_name", label: "Origin Hub", sortable: true },
        { key: "Action", label: "Action", sortable: true },
      ],
      isBusy: false,
      totalRows :0,
      viewriderlogdetails :false,
      isBusymodel : false,
      riderlist: [],
      fieldsr: [
        { key: "tripid", label: "Trip Id", sortable: true },
        { key: "parentawb", label: "Comment", sortable: true },
        // { key: "startlatlong", label: "Start Latlong", sortable: true },
        { key: "endlatlong", label: "Latlong", sortable: true },
        { key: "distance", label: "Distance", sortable: true },
        { key: "createdby", label: "Created By", sortable: true },
        { key: "createddate", label: "Createddate", sortable: true },
      ],
      totalRowsmodel :0,



      //map 


      viewmap : false,
      ourMap:null,
      center: {
        lat: 0,
        lng: 0
      },
      // startlatlong : null,
      // endlatlong : null,
      ridermaplist :[],
      paths : [],
      noofpages:'',
      pageNum:1,
      listingpageno:1,
      currentPage: 1,
      perPage:  20,

      startlatlong:{},
      // map 
      Loadmap:null,

      vehicleNumberSearch: '',
      selectedVehicleNumber: null,
      vehicleNumbers: [], // { value: vehicle_id, text: vehicle_no }

      tripIdSearch: '',
      selectedTripId: null,
      tripIds: [], // { value: tripid, text: tripid }

      vehicleitems: [],
      selected_vehicleno: null,
      tripIdItems: [], // Added for v-select
    };
  },
  computed: {
    filteredVehicleNumbers() {
      if (!this.vehicleNumberSearch) return this.vehicleNumbers;
      return this.vehicleNumbers.filter(v => v.text && v.text.toLowerCase().includes(this.vehicleNumberSearch.toLowerCase()));
    },
    filteredTripIds() {
      if (!this.tripIdSearch) return this.tripIds;
      return this.tripIds.filter(t => t.text && t.text.toLowerCase().includes(this.tripIdSearch.toLowerCase()));
    },
  },
  watch: {
    selectedVehicleNumber(newVal) {
      this.selectedTripId = null;
      this.tripIds = [];
      if (newVal) {
        this.fetchTripIdsForVehicle(newVal);
      }
    },
  },
  created() {
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    this.VehicleListings(this.pageNum);
    this.fetchVehicleItems();
  },
  // mounted() {
  //   this.initMap();
  // },
  methods: {

    clickCallback (pageNum){
      this.listingpageno = pageNum;
      this.VehicleListings(pageNum);
    },

    VehicleListings: function(pageNum) {
      this.isBusy = true;
      let userdata = localStorage.getItem("userData");
      let userInfo = JSON.parse(userdata);

      var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
      var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";

      const obj = {
        fromDate: fromdate,
        toDate: formatdateto,
        page_no :`${pageNum}`
      };
      if (this.selected_vehicleno && this.selected_vehicleno.key) {
        obj.vehicle_id = this.selected_vehicleno.key;
      }
      if (this.selectedTripId && this.selectedTripId.key) {
        obj.tripid = this.selectedTripId.key;
      }

      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/optimizedVehicleTripListing`, obj)
        .then((result) => {
          this.isBusy = false;
          if (result.body.returnmsg === "Successful") {
            this.vehiclelist = result.body.returnvalue;    
            this.totalRows = result.body.totalcount;
            this.noofpages=parseInt(this.totalRows)/20;
            this.noofpages=Math.ceil( this.noofpages);

          } else {
            this.vehiclelist = [];
            this.totalRows = 0;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    TripListings: function(data) {
      console.log("data",data)
      this.isBusymodel = true;
      let userdata = localStorage.getItem("userData");
      let userInfo = JSON.parse(userdata);
      const obj = {
          tripid: data.tripid,
          vehicle_id: `${data.vehicle_id}`,
          // tripid:'20231019112640',
          // vehicle_id: `543`,
      };
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getvehicleloadwisedetails`, obj)
        .then((result) => {
          this.isBusymodel = false;

          if (result.body.returnmsg === "Successful") {
            this.riderlist = result.body.returnvalue;    
            this.totalRowsmodel = result.body.returnvalue.length;
          } else {
            this.riderlist = [];
            this.totalRowsmodel = 0;
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    
    openmodelriderdetails(value){
      this.riderlist=[]
      this.viewriderlogdetails=true;
      this.TripListings(value);
    },

    hideModal(){
      this.riderlist=[]
      this.viewriderlogdetails=false;
    },

    clear(){
      this.selectDateFrom = new Date();
      this.selectDateTo = new Date();
      this.selected_vehicleno = null;
      this.selectedTripId = null;
      this.tripIds = [];
      this.VehicleListings(this.pageNum);
    },

    // open_mapmodel(value){
    //   this.ridermaplist =[]
    //   this.viewmap = true;
    //   console.log("value",value.startlatlong)
      
    //   let userdata = localStorage.getItem("userData");
    //   let userInfo = JSON.parse(userdata);
    //   const obj = {
    //       tripid: value.tripid,
    //       vehicle_id: `${value.vehicle_id}`,
    //       // tripid:'20231019112640',
    //       // vehicle_id: `543`,
    //   };
    //   this.$http
    //     .post(`${CONSTANTS.MIGRATION_API_URL}/getvehicleloadwisedetails`, obj)
    //     .then((result) => {

    //       if (result.body.returnmsg === "Successful") {
    //         this.ridermaplist = result.body.returnvalue;    
    //         console.log(" this.ridermaplist", this.ridermaplist)




    //         var startlat = this.ridermaplist[0].startlatlong
     
    //         if (startlat != null && startlat !="") {
    //           var startlat0 = startlat.split(",")[0];
    //           var endlat0 = startlat.split(",")[1];
        
        
    //           var lat = parseFloat(startlat0);
    //           var lng = parseFloat(endlat0);

    //           var centerCoordinates = { lat: lat, lng: lng };

    //           this.center=centerCoordinates;

    //           console.log("ccccc",this.center)

    //           this.initMap();
    //           const startMarker = new google.maps.Marker({
    //             position: this.center,
    //             map: this.ourMap,
    //             label:'S',
    //             title: 'Start Point',
    //           });

    //          for (let i = 0; i < this.ridermaplist.length; i++) {
    //             var latlong = this.ridermaplist[i].startlatlong;
    //             if (latlong != null && latlong !="") {
    //               var startlatlong = latlong.split(",")[0];
    //               var endlatlong = latlong.split(",")[1];
    //             }
        
    //             var lat_start = parseFloat(startlatlong);
    //             var lng_end = parseFloat(endlatlong);

    //             var path = {
    //               lat : parseFloat(lat_start),
    //               lng : parseFloat(lng_end)
    //             };
    //             this.paths.push(path)
    //           }

    //           this.paths.forEach((endLatLng, index) => {
    //             const endMarker = new google.maps.Marker({
    //               position: endLatLng,
    //               map: this.ourMap,
    //               label:'D',
    //               title: `End Point ${index + 1}`,
    //             });

    //             const line = new google.maps.Polyline({
    //               path: this.paths,
    //               geodesic: true,
    //               strokeColor: '#FF0000',
    //               strokeOpacity: 1.0,
    //               strokeWeight: 2,
    //             });

    //             line.setMap(this.ourMap);
    //           });
    //         }
    //       } else {
    //         this.ridermaplist = [];
    //       }
    //     })
    //     .catch((ex) => {
    //       console.log("error", ex);
    //     });
    // },

    // initMap() {
    //   this.ourMap = new google.maps.Map(document.getElementById('map'), {
    //     center: this.center,
    //     zoom: 8,
    //   });
    // },

    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");

    },



    // map start

    viewMapData(vehicle){
      if (vehicle.destination_sequence.length>0) {
        console.log("-----------------",vehicle)
      // this.startlatlong = '';
        let waypoints = vehicle.destination_sequence;

        // this.startlatlong = waypoints[0].startlatlong


        var startlatlong= {
          "lat": parseFloat(waypoints[0].startlatlong.x),
          "lng": parseFloat(waypoints[0].startlatlong.y)
        }
        console.log("this.startlatlong",startlatlong)



        this.waypoints= waypoints.map(item=>({
          "lat": parseFloat(item.endlatlong.x),
          "lng": parseFloat(item.endlatlong.y)
        }))
        this.waypoints.unshift(startlatlong);
        // this.waypoints=waypoints.map(item=>({
        //   "lat": parseFloat(item.lat),
        //   "lng": parseFloat(item.lng)
        // }))


        this.viewmap=true;
      } else {
        this.$fire({
            text: `Data Not Found`,
            type: "warning",
            timer: 30000
          });
          return false;
      }
    
    },
    initMapLoad() {
        this.Loadmap = new google.maps.Map(document.getElementById('map'), {
          center: { lat: 12.971598, lng: 77.594562 },
          zoom: 15,
        });

        const directionsService = new google.maps.DirectionsService();
        this.directionsRenderers = new google.maps.DirectionsRenderer({ map: this.Loadmap });


        const waypointsLatLng = this.waypoints.map(waypoint => new google.maps.LatLng(waypoint.lat, waypoint.lng));
        // console.log("---------------------",this.waypoints)
        const request = {
          origin: waypointsLatLng[0],
          destination: waypointsLatLng[waypointsLatLng.length - 1],
          waypoints: this.waypoints.slice(1, -1).map(waypoint => ({
            location: new google.maps.LatLng(waypoint.lat, waypoint.lng),
            stopover: true
          })),
          travelMode: google.maps.TravelMode.DRIVING,
        };
        directionsService.route(request, (result, status) => {
          if (status === 'OK') {
            this.directionsRenderers.setDirections(result);
          } else {
            window.alert('Directions request failed due to ' + status); window.alert('Directions request failed due to ' + status);
          }
        });

        // Place markers at each waypoint
        this.waypoints.forEach((waypoint, index) => {
          // const marker = new google.maps.Marker({
          //   position: { lat: waypoint.lat, lng: waypoint.lng },
          //   map: this.Loadmap,
          //   title: `(${waypoint.lat}, ${waypoint.lng})`,
          //   icon: {
          //     path: google.maps.SymbolPath.CIRCLE,
          //     fillColor: index === 0 ? 'green' : (index === this.waypoints.length - 1 ? 'red' : 'yellow'),
          //     fillOpacity: 1,
          //     strokeColor: 'black',
          //     strokeWeight: 2,
          //     scale: 8 // Adjust the scale as needed
          //   }
          // });
        });

    },

    // map end 

    fetchVehicleNumbers() {

      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // Use new API and payload
      const payload = {
        sysusermasterid: `${userInfo.sysusermasterid}`,
        usertype: `${userInfo.user_type}`,
        isactive: "1",
      };
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleListing`, payload)
        .then((result) => {
          if (Array.isArray(result.body) && result.body.length > 0) {
            this.vehicleNumbers = result.body
              .filter(v => v.vehicle_no && v.vehicle_no.trim() !== "")
              .map(v => ({ value: v.vehicle_id, text: v.vehicle_no }));
          } else {
            this.vehicleNumbers = [];
          }
        })
        .catch((ex) => {
          this.vehicleNumbers = [];
          console.log("error", ex);
        });
    },

    fetchTripIdsForVehicle(vehicleId) {
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/fetchTripIdsForVehicle`, { vehicle_id: vehicleId })
        .then((result) => {
          if (result.body.returnmsg === "Successful") {
            const uniqueTripIds = Array.from(new Set(result.body.returnvalue.map(t => t.tripid)));
            this.tripIdItems = uniqueTripIds.map(tripid => ({ key: tripid, label: tripid }));
          } else {
            this.tripIdItems = [];
          }
        })
        .catch((ex) => {
          this.tripIdItems = [];
          console.log("error", ex);
        });
    },

    fetchVehicleItems() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const payload = {
        sysusermasterid: `${userInfo.sysusermasterid}`,
        usertype: `${userInfo.user_type}`,
        isactive: "1",
        vehicle_type: "bulkreallocate",
      };
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleListing`, payload)
        .then((result) => {
          if (Array.isArray(result.body) && result.body.length > 0) {
            this.vehicleitems = result.body
              .filter(v => v.vehicle_no && v.vehicle_no.trim() !== "")
              .map(v => ({ key: v.vehicle_id, label: v.vehicle_no }));
          } else {
            this.vehicleitems = [];
          }
        })
        .catch((ex) => {
          this.vehicleitems = [];
          console.log("error", ex);
        });
    },

    selectsearchvehicle(value_vehicle) {
      if (value_vehicle == null) {
        this.selected_vehicleno = null;
        this.selectedTripId = null;
        this.tripIdItems = [];
      } else {
        this.selectedTripId = null;
        this.tripIdItems = [];
        this.fetchTripIdsForVehicle(value_vehicle.key);
      }
    },
  },
};
</script>

<style>
.selectbutton span {
font-weight: 599 !important;
}
</style>
